import React from 'react'

function Payment() {
  return (
 <div><main className="page-content page-content-ones">
    <div className="tm-section tm-my-account-area bg-white tm-padding-section">
      <div className="container">
        <div className="tm-myaccount">
          <div className="tab-content" id="account-ontent">
            <div className="tab-pane fade show active" id="account-dashboard" role="tabpanel" aria-labelledby="account-dashboard-tab">
              <div className="tm-myaccount-dashboard1">
                <div className="cart-box-two">
                  <div className="row">
                    <div className="col-lg-8 col-md-6">
                      <div className="my-wishlist my-wishlist-one contact-form">
                        <h4> Choose Payment Mode </h4>
                      </div>
                      <div className="cart-box1 cart-box11 contact-form">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="cart-text cart-text1 cart-text12">
                              <form className="full-form">
                                <h2><span> Recommended Payment Options</span></h2>
                                <div className="payment-last">
                                  <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" defaultValue="option1" defaultChecked />
                                    <label className="form-check-label" htmlFor="exampleRadios1">
                                      Razorpay
                                    </label>
                                    <span><img src="assets/images/pay1-icon.png" /></span>
                                  </div>
                                  <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" defaultValue="option2" />
                                    <label className="form-check-label" htmlFor="exampleRadios2">
                                      Cash on Delivery (Cash/UPI)
                                    </label>
                                    <span className="pay-icon"><img src="assets/images/pay2-icon.png" /></span>
                                  </div>
                                  <div className="form-check">
                                    <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" defaultValue="option2" />
                                    <label className="form-check-label" htmlFor="exampleRadios3">
                                      PhonePe
                                    </label>
                                    <span className="pay-icon1"><img src="assets/images/pay3-icon.png" /></span>
                                  </div>
                                </div>
                                <a href="thanks.html" className="add-men-btn">PAY NOW</a>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="giftcard-base-container paymentDesktop-base-giftCardBlock"><svg xmlns="http://www.w3.org/2000/svg" width={20} height={19} viewBox="0 0 20 19" className="giftcard-base-giftIcon"><path fillRule="evenodd" stroke="#000" strokeWidth=".2" d="M18.1 7.26h-5.85V4.577h5.85v2.685zm-5.85 9.845h4.95v-8.95h-4.95v8.95zm-9.45 0h4.95v-8.95H2.8v8.95zM1.9 4.576h5.85v2.685H1.9V4.576zm4.295-2.073c-.01-.098 0-.264.193-.464.12-.089.25-.11.402-.11.653 0 1.565 1.081 2.25 1.752H6.886c-.263-.224-.656-.835-.691-1.178zm5.155 14.602h-2.7V4.576h2.7v12.53zm1.879-15.183c.152 0 .28.028.401.117.194.2.204.371.194.47-.036.358-.45.948-.693 1.172h-2.152c.685-.671 1.596-1.759 2.25-1.759zm5.323 1.76h-4.279c.218-.225.408-.71.446-1.087.031-.303-.026-.77-.475-1.213-.012-.012-.025-.03-.038-.04a1.552 1.552 0 0 0-.977-.34c-1.248 0-2.587 1.527-3.22 2.342C9.376 2.529 8.037 1 6.79 1a1.549 1.549 0 0 0-1.015.37c-.449.442-.506.922-.475 1.225.039.376.228.862.446 1.086H1.448c-.247 0-.448.15-.448.4v3.61c0 .25.2.465.448.465H1.9v9.37c0 .246.19.474.42.474h15.363c.23 0 .417-.228.417-.474v-9.37h.452A.46.46 0 0 0 19 7.692V4.08c0-.25-.2-.4-.448-.4z" /></svg><span className="giftcard-base-title">Have a Gift Card?</span><span className="giftcard-base-apply">APPLY GIFT CARD</span></div>
                    </div>
                    <div className="col-lg-4 col-md-6 ">
                      <div className="my-wishlist my-wishlist-one">
                        <h4>Details</h4>
                      </div>
                      <div className="cart-right">
                        <div className="my-wishlist my-wishlist-one">
                          <h4>Price Details</h4>
                        </div>
                        <div className="cart-box2">
                          <div className="row">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>Total MRP</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>+ ₹460</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>Discount on MRP</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2 className="discount-text">- ₹49</h2>
                              </div>
                            </div>
                          </div>
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left">
                                <h2>Coupon Discount</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right">
                                <h2>Apply Coupon</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cart-box3">
                          <div className="row card-right-center">
                            <div className="col-lg-6 col-6">
                              <div className="two-left two-left1">
                                <h2>Total Amount</h2>
                              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                              <div className="two-right two-right1">
                                <h2>₹411</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-orders" role="tabpanel" aria-labelledby="account-orders-tab">
              <div className="tm-myaccount-orders">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="tm-myaccount-orders-col-id">ORDER ID</th>
                        <th className="tm-myaccount-orders-col-date">DATE</th>
                        <th className="tm-myaccount-orders-col-status">STATUS</th>
                        <th className="tm-myaccount-orders-col-total">TOTAL</th>
                        <th className="tm-myaccount-orders-col-view">VIEW</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>#12345</td>
                        <td>30 December 2018</td>
                        <td>On Hold</td>
                        <td>₹ 132.00 for 2 items</td>
                        <td><a href="#" className="tm-button tm-button-small">View</a>
                        </td>
                      </tr>
                      <tr>
                        <td>#12346</td>
                        <td>30 December 2018</td>
                        <td>On Hold</td>
                        <td>₹ 220.00 for 3 items</td>
                        <td><a href="#" className="tm-button tm-button-small">View</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-address" role="tabpanel" aria-labelledby="account-address-tab">
              <div className="tm-myaccount-address">
                <p><b>The following addresses will be used on the checkout page by default.</b></p>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="tm-myaccount-address-billing">
                      <a href="#" className="edit-button">Edit</a>
                      <h3>Billing Address</h3>
                      <address>
                        Jonathon Doe<br />
                        Example company<br />
                        516 Wintheiser Circles <br />
                        Lake Jordanmouth <br />
                        Jordan
                      </address>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mt-30 mt-md-0">
                    <div className="tm-myaccount-address-shipping">
                      <a href="#" className="edit-button">Edit</a>
                      <h3>Shipping Address</h3>
                      <address>
                        Jonathon Doe<br />
                        Example company<br />
                        516 Wintheiser Circles <br />
                        Lake Jordanmouth <br />
                        Jordan
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane fade" id="account-acdetails" role="tabpanel" aria-labelledby="account-acdetails-tab">
              <div className="tm-myaccount-acdetails">
                <form action="#" className="tm-form tm-form-bordered">
                  <h4>Account Details</h4>
                  <div className="tm-form-inner">
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-firstname">First name</label>
                      <input type="text" id="acdetails-firstname" />
                    </div>
                    <div className="tm-form-field tm-form-fieldhalf">
                      <label htmlFor="acdetails-lastname">Last name</label>
                      <input type="text" id="acdetails-lastname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-displayname">Dispaly name</label>
                      <input type="text" id="acdetails-displayname" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-email">Email address</label>
                      <input type="email" id="acdetails-email" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-password">Old password</label>
                      <input type="password" id="acdetails-password" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-newpassword">New password</label>
                      <input type="password" id="acdetails-newpassword" />
                    </div>
                    <div className="tm-form-field">
                      <label htmlFor="acdetails-confirmpass">Confirm password</label>
                      <input type="password" id="acdetails-confirmpass" />
                    </div>
                    <div className="tm-form-field">
                      <input type="checkbox" name="acdetails-agreeterms" id="acdetails-agreeterms" />
                      <label htmlFor="acdetails-agreeterms">I have read and agree to the Privacy
                        Policy</label>
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button">Save Changes</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Payment